import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

// Types
import { Illustrations } from 'Wpds/components/illustration';

// Components
import { WpPageLayout, WpPageHeader, WpPageBody, WpPageTitle } from 'Wpds/components/page-layout';
import AssistantCard from './AssistantCard/AssistantCard';

// Hooks
import { useOrganization } from 'Shared/utils/hooks/use-organization';

import './Assistants.scss';

const Assistants = () => {
  const { featureFlagShowSalesAssistant } = useFlags();
  const { organization } = useOrganization();

  const manager_assistant_info = {
    key: 'manager',
    title: 'Good Manager Assistant',
    description: 'Automate manager best practices',
    buttonText: 'Settings',
    showComingSoon: false,
    image: Illustrations.helping_hand_climbing_mountain_white_bg,
    path: '/assistants/manager/settings',
  };

  const sales_assistant_info = {
    key: 'sales',
    title: 'Sales Assistant',
    description: 'Automate repetitive data entry for your sales reps',
    path: organization?.salesforce_organization_data_source ? '/assistants/sales/' : '/assistants/sales/connect',
    image: Illustrations.person_looking_through_lens_white_bg,
  };

  const assistants =
    organization.employer.isConsumer || !featureFlagShowSalesAssistant
      ? [manager_assistant_info]
      : [manager_assistant_info, sales_assistant_info];

  const baseClassName = 'AssistantsPage';

  return (
    <WpPageLayout width="container" className={baseClassName}>
      <WpPageHeader>
        <WpPageTitle title="Assistants" subTitle="Your automated robot assistants that turn you into a super human" />
      </WpPageHeader>
      <WpPageBody>
        <div className={`${baseClassName}__body`}>
          {assistants.map(props => (
            <AssistantCard {...props} key={`assistant-${props.key}`} />
          ))}
        </div>
      </WpPageBody>
    </WpPageLayout>
  );
};

export default Assistants;
